class FortuneTailHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-mobile-menu-toggle]');
    this.panel = this.querySelector('[data-mobile-menu-panel]');
    this.announcement = this.querySelector('[data-header-announcement]');
    this.slides = this.announcement ? Array.from(this.announcement.querySelectorAll('[data-announcement-slide]')) : [];
    this.currentSlide = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleAnnouncementClick = this.handleAnnouncementClick.bind(this);

    if (this.toggle && this.panel) {
      this.toggle.addEventListener('click', this.handleToggle.bind(this));
    }

    if (this.announcement) {
      this.announcement.addEventListener('mouseenter', () => this.stopRotation());
      this.announcement.addEventListener('mouseleave', () => this.startRotation());
      this.announcement.addEventListener('focusin', () => this.stopRotation());
      this.announcement.addEventListener('focusout', () => this.startRotation());
      this.announcement.addEventListener('click', this.handleAnnouncementClick);
      this.startRotation();
    }

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    this.stopRotation();
    this.announcement?.removeEventListener('click', this.handleAnnouncementClick);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleToggle() {
    const isOpen = this.classList.toggle('is-menu-open');
    this.toggle.setAttribute('aria-expanded', String(isOpen));
    this.panel.hidden = !isOpen;
  }

  handleScroll() {
    this.classList.toggle('is-announcement-collapsed', window.scrollY > 24);
  }

  handleAnnouncementClick(event) {
    const trigger = event.target.closest('[data-newsletter-popup-trigger]');
    if (!trigger) return;
    event.preventDefault();
    window.FortuneTailNewsletter?.open();
  }

  startRotation() {
    this.stopRotation();
    if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const delay = Number(this.announcement.dataset.rotationSpeed) || 5000;
    this.rotationTimer = window.setInterval(() => this.showNextSlide(), delay);
  }

  stopRotation() {
    if (this.rotationTimer) {
      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }
  }

  showNextSlide() {
    const current = this.slides[this.currentSlide];
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    const next = this.slides[this.currentSlide];
    current.classList.remove('is-active', 'is-entering');
    current.hidden = true;
    next.hidden = false;
    next.classList.add('is-active', 'is-entering');
  }
}

if (!customElements.get('fortune-tail-header')) {
  customElements.define('fortune-tail-header', FortuneTailHeader);
}
